export const mapLangListToAutocomplete = (LangList) =>
    Array.isArray(LangList)
        ? LangList.map((item) => ({
            id: item.Id,
            selectOptionLabel: `${item.LanguageCode}-${item.LanguageDescription}`,
            selectOptionValue: item.Id,
        }))
        : [];
export const mapCurrencyListToAutocomplete = (CurrencyList) =>
    Array.isArray(CurrencyList)
        ? CurrencyList.map((item) => ({
            id: item.Id,
            selectOptionLabel: `${item.CurrencyCode}`,
            selectOptionValue: item.Id,
        }))
        : [];
export const mapClientTypeListToAutocomplete = (ClientTypeList) =>
    Array.isArray(ClientTypeList)
        ? ClientTypeList.map((item) => ({
            id: item.DataClassificationKey,
            selectOptionLabel: `${item.MasterDataClassificationName}`,
            selectOptionValue: item.DataClassificationKey,
        }))
        : [];
export function setClientCodes(finalCodeList, setValue) {
    if (Array.isArray(finalCodeList) && finalCodeList.length) {
        const list = finalCodeList.map(item => item.clientCode);
        setValue('client_codes', list.toString(), { shouldValidate: true });
    } else {
        setValue('client_codes', "");
    }
}